/**
 * @name UpdateClientModalController
 * @description Function to update clients who are still new users
 * @param {unknown} $uibModalInstance UI Bootstrap image modal instance
 * @param {unknown} Collector The Collector service
 * @param {unknown} client Resolved client from the client list controller
 * @param {unknown} _ Underscore service
 */
function UpdateClientModalController(
$uibModalInstance,
Collector,
client,
_) {
  let vm = this;
  client.new_email = client.email;
  vm.client = client;
  vm.updateClient = updateClient;

  /**
   * @name updateClient
   * @description Function to update the artist association
   * @param {object} client The client's collector object you want to update
   */
  function updateClient(client) {
    if (client.new_email == client.email) {
      client.new_email = '';
    }
    Collector.updateCollector(client).then(function(response) {
      $uibModalInstance.close();
      client.email = response.data.email;
    });
  }

  vm.cancel = function() {
    vm.client = client;
    $uibModalInstance.dismiss();
  };
}

angular
  .module('inkfinder')
  .controller('UpdateClientModalController', UpdateClientModalController);



// WEBPACK FOOTER //
// ./components/clients-list/update/update-client-modal.controller.js